import r from "./_Symbol.js";
import o from "./_getRawTag.js";
import a from "./_objectToString.js";
var e = r, g = o, i = a, T = "[object Null]", f = "[object Undefined]", n = e ? e.toStringTag : void 0;
function b(t) {
  return t == null ? t === void 0 ? f : T : n && n in Object(t) ? g(t) : i(t);
}
var u = b;
export {
  u as default
};
//# sourceMappingURL=_baseGetTag.js.map
